import { IRequestOptions, PeekdataApi } from 'peekdata-datagateway-api-sdk';
import { ReportsApi } from './ReportsApi';
import { UsersApi } from './UsersApi';

export const apiRequestOptions: IRequestOptions = {
  baseUrl: process.env.PEEKDATA_API_URL,
  timeout: Number(process.env.PEEKDATA_DEFAULT_TIMEOUT),
};

export const peekdataApi = new PeekdataApi(apiRequestOptions);
export const reportsApi = new ReportsApi(apiRequestOptions);
export const usersApi = new UsersApi(apiRequestOptions);
